import type * as React from 'react';
import { css } from '@emotion/react';
import { theme } from '@Guidelines/Theme/theme';

const eyebrowStyle = css`
	${theme.typography.eyebrow}
	margin: 0;
	text-transform: uppercase;
	color: ${theme.colors.inkMuted};
`;

type Props = {
	readonly className?: string;
	readonly children: React.ReactNode;
};

const Eyebrow: React.FC<Props> = ({ className, children }) => {
	return (
		<p css={eyebrowStyle} className={className}>
			{children}
		</p>
	);
};

export default Eyebrow;
